import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { authApi } from "@/lib/agenda";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = comprobando, false = no autenticado, obj = usuario

  const check = useCallback(async () => {
    if (window.location.hash && window.location.hash.includes("session_id=")) {
      setUser(false);
      return;
    }
    try {
      const u = await authApi.me();
      setUser(u);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const u = await authApi.login(email, password);
    setUser(u);
    return u;
  };
  const register = async (email, password, name) => {
    const u = await authApi.register(email, password, name);
    setUser(u);
    return u;
  };
  const logout = async () => {
    try { await authApi.logout(); } catch { /* ignore */ }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
